"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BoltTrendUtils";

export default function BoltCorrectScoresSection({ title, correctScoresFull }) {
  const { home = [], draw = [], away = [] } = correctScoresFull || {};
  const allScores = [...home, ...draw, ...away];

  if (allScores.length === 0) return null;

  return (
    <div className="ods-detail-item ods-100">
      <div className="odstb-title">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="odstb-odds-list scores-grid">
        {home.map((item, i) => (
          <div key={`h${i}`}>
            <div className="title-odds">{item.label}</div>
            <div className="score-values">
              <div className={`odds ods-100 ods-white ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`odds ods-100 ods-white ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        {draw.map((item, i) => (
          <div key={`d${i}`}>
            <div className="title-odds">{item.label}</div>
            <div className="score-values">
              <div className={`odds ods-100 ods-white ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
            </div>
          </div>
        ))}
        {away.map((item, i) => (
          <div key={`a${i}`}>
            <div className="title-odds">{item.label}</div>
            <div className="score-values">
              <div className={`odds ods-100 ods-white ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`odds ods-100 ods-white ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        <div>
          <div className="title-odds">AOS</div>
          <div className="score-values">
            <div className="odds ods-100 ods-white">-</div>
          </div>
        </div>
      </div>
    </div>
  );
}
